import {
  Header1,
  Instruction,
  InstructionWithContent,
} from "../../BlockComponent";
import {
  ButtonGroup,
  GuideTypographyLine,
  LineWithSolidLabel,
  TypographyLine,
} from "../../CellComponent";
import { LastCard } from "../common";

export const Content_2_4_A = [
  Instruction("typography_0"),
  Instruction("typography_1"),

  InstructionWithContent(
    `typography_2`,
    LineWithSolidLabel("상황", TypographyLine("typography_2_1"))
  ),
  InstructionWithContent(`typography_3`, [
    ...LineWithSolidLabel("생각", TypographyLine("typography_3_1")),
  ]),
  InstructionWithContent(
    `typography_4`,
    LineWithSolidLabel("감정", TypographyLine("typography_4_1"))
  ),
  InstructionWithContent(
    `typography_5`,
    LineWithSolidLabel("신체 반응", TypographyLine("typography_5_1"))
  ),
  InstructionWithContent(
    `typography_6`,
    LineWithSolidLabel("행동", TypographyLine("typography_6_1"))
  ),

  Instruction("typography_7_0_0"),

  Header1("typography_7"),

  Instruction(`typography_8`),
  Instruction("typography_9"),

  InstructionWithContent(`typography_10`, [
    ...LineWithSolidLabel("상황", TypographyLine("typography_10_1")),
    [
      ButtonGroup(
        [
          {
            text: "잘 적혔어요",
          },
          {
            text: "아니요, 잘못 적혔어요",
          },
        ],
        { id: "quiz1" }
      ),
    ],

    GuideTypographyLine("typography_quiz1_incorrect", {
      answerList: [{ id: "quiz1", answerIndex: 1 }],
    }),
  ]),

  Instruction("typography_11"),
  InstructionWithContent(
    `typography_12`,
    LineWithSolidLabel("상황", TypographyLine("typography_12_1"))
  ),


  // quiz2
  Instruction(`typography_12_2_0`),
  Instruction(`typography_12_2_1`),
  Instruction(`typography_12_2_2`),
  Instruction(`typography_12_2_3`),

  InstructionWithContent(`typography_12_3_0`, [
    ...LineWithSolidLabel("상황", TypographyLine("typography_12_3_1")),
    [
      ButtonGroup(
        [
          {
            text: "잘 적혔어요",
          },
          {
            text: "아니요, 잘못 적혔어요",
          },
        ],
        { id: "quiz1_2" }
      ),
    ],

    GuideTypographyLine("typography_quiz1_2_incorrect", {
      answerList: [{ id: "quiz1_2", answerIndex: 1 }],
    }),
  ]),

  Instruction("typography_12_3_2"),

  InstructionWithContent(
    `typography_12_4_1`,
    LineWithSolidLabel("상황", TypographyLine("typography_12_4_2"))
  ),

  Instruction("typography_12_5_1"),
  Instruction("typography_12_5_2"),
  Instruction("typography_12_5_3"),

  Header1("typography_13"),
  Instruction("typography_14_1_0"),
  Instruction("typography_15"),

  InstructionWithContent(`typography_15_0_0`, [
    ...LineWithSolidLabel("생각", TypographyLine("typography_15_0_1")),
    [
      ButtonGroup(
        [
          {
            text: "잘 적혔어요",
          },
          {
            text: "아니요, 잘못 적혔어요",
          },
        ],
        { id: "quiz2_0" }
      ),
    ],

    GuideTypographyLine("typography_quiz2_0_incorrect", {
      answerList: [{ id: "quiz2_0", answerIndex: 1 }],
    }),
  ]),

  Instruction("typography_15_0_3"),
  InstructionWithContent(
    `typography_15_0_4`,
    LineWithSolidLabel("생각", TypographyLine("typography_15_0_5"))
  ),
  Instruction("typography_16"),
  Instruction("typography_16_0_1"),
  Instruction("typography_16_0_2"),
  Instruction("typography_16_0_3"),
  Instruction("typography_16_0_4"),

  InstructionWithContent(`typography_17`, [
    ...LineWithSolidLabel("생각", TypographyLine("typography_17_1")),
    [
      ButtonGroup(
        [
          {
            text: "잘 적혔어요",
          },
          {
            text: "아니요, 잘못 적혔어요",
          },
        ],
        { id: "quiz2" }
      ),
    ],

    GuideTypographyLine("typography_quiz2_incorrect", {
      answerList: [{ id: "quiz2", answerIndex: 1 }],
    }),
  ]),

  Instruction("typography_18"),
  InstructionWithContent(
    `typography_19`,
    LineWithSolidLabel("생각", TypographyLine("typography_19_1"))
  ),

  Header1("typography_23"),
  InstructionWithContent(
    `typography_24`,
    LineWithSolidLabel("감정", TypographyLine("typography_24_1"))
  ),
  Instruction("typography_25"),

  Header1("typography_26"),
  InstructionWithContent(
    `typography_27`,
    LineWithSolidLabel("신체 반응", TypographyLine("typography_27_1"))
  ),
  Instruction("typography_28"),
  Instruction("typography_28_0_1"),
  Instruction("typography_28_0_2"),
  Instruction("typography_28_0_3"),
  Instruction("typography_28_0_4"),

  Header1("typography_29"),
  InstructionWithContent(
    `typography_30`,
    LineWithSolidLabel("행동", TypographyLine("typography_30_1"))
  ),
  Instruction("typography_31"),
  Instruction("typography_32"),
  Instruction("typography_32_0_1"),
  Instruction("typography_32_0_2"),
  Instruction("typography_32_0_3"),
  Instruction("typography_32_0_4"),

  Header1("typography_33_0_0"),
  Instruction("typography_33"),
  Instruction("typography_33_0_1"),
  Instruction("typography_34"),

  ...LastCard,
];
